(exports.OP_ID = "6aa9632fb687631c460ba216"),
  (exports.IDGAME = "2026-husqvarna-646"),
  (exports.FORM_ID = "6aa96330b687631c460ba22d"),
  (exports.SERVER_URL = "https://api.accompagnement-hva.fr"),
  (exports.CUSTOM_API = "/api/operations-custom/2026-husqvarna-646"),
  (exports.ITEMS = "6aa96330b687631c460ba22d"),
  (exports.BD_NAME = "jeu-dev");
